import Spinner from "@/components/Spinner";
import clsx from "clsx";
import { SendIcon } from "lucide-react";
interface Props {
	disabled: boolean;
	loading: boolean;
	onSubmit: () => void;
}
export default function SubmitBtn(props: Props) {
	return (
		<div
			className="ml-3 mr-4 flex h-11 w-11 items-center justify-center"
			onClick={() => {
				if (props.disabled) return;
				props.onSubmit();
			}}
		>
			<div
				className={clsx(
					"flex h-full w-full items-center justify-center rounded-full text-white",
					props.disabled ? "bg-[#2E0071]/80" : "bg-[#2E0071]",
				)}
			>
				{props.loading ? <Spinner size="sm" className="text-white" /> : <SendIcon color={"#fff"} />}
			</div>
		</div>
	);
}
